<app-vis-dialog title="Boss Snake 小遊戲" class="main-panel" [show]="show" (close)="close()">
  <div class="status-panel">
    <div class="boss-status">
      <div class="boss-bar-wrapper">
        <div class="burn-indicator" *ngIf="isBurning">
          <span>🔥</span>
          <span class="burn-damage">{{ (burnTickDamage|| 0) }}</span>
        </div>
        <div class="boss-bar" [class.invulnerable]="isInvulnerable()">
          <div class="boss-bar__fill" [style.width.%]="(bossHp / bossMaxHp) * 100" [class.invulnerable]="isInvulnerable()"></div>
          <div class="boss-bar__label">
            HP: {{ bossHp }}/{{ bossMaxHp }}
            <span class="burn-label" *ngIf="isBurning">🔥</span>
          </div>
        </div>
      </div>
      <div class="armor-row">
        <span *ngFor="let slot of armorSlots" class="armor-slot">🛡️</span>
      </div>
      <div class="skill-message" *ngIf="skillMessage">
        {{ skillMessage.text }}<span *ngIf="skillMessage.damage !== null"> - {{ skillMessage.damage }} 傷害</span>
      </div>
    </div>
    <div class="attack-readout">
      <div class="attack-readout__label">攻擊力</div>
      <div class="attack-readout__value">{{ baseAttackPower }} ({{ buffedAttackPower }})</div>
    </div>
    <div class="satiety-display">
      {{ satietyLabel }} {{ satietyPercent }}%
    </div>
  </div>
  <div class="skill-queue">
    <div class="skill-queue__label">技能道具</div>
    <div class="skill-queue__items">
      <span *ngFor="let slot of skillSlots" class="skill-slot">{{ skillIcon(slot) }}</span>
    </div>
  </div>
  <div class="weapon-row" mat-dialog-actions>
    <div class="weapon-row__slots">
      <span *ngFor="let slot of weaponSlots; let idx = index" class="weapon-slot" [class.filled]="idx < weaponCharge">⚔️</span>
    </div>
    <div class="weapon-row__label">武器進度 {{ weaponCharge }}/3</div>
    <button mat-button (click)="togglePause()" [disabled]="gameOver">{{ paused ? '繼續' : '暫停' }}</button>
    <button mat-button (click)="resetGame()">重新開始</button>
  </div>
  <div mat-dialog-content class="canvas-container">
    <canvas #canvas width="400" height="400"></canvas>
  </div>
</app-vis-dialog>
